import { filter, map } from 'rxjs/operators';

import { lookupAddress } from '../../../features/address-verification/reducers/addressLookup';
import { saveBusinessInfoTwo } from '../../../features/application/reducers/business-info';
import { RootEpic } from '../index';

export const saveBusinessInfoTwoEpic: RootEpic = (action$) =>
  action$.pipe(
    filter(saveBusinessInfoTwo.match),
    map(({ payload: { address } }) =>
      lookupAddress({
        address,
        type: 'business',
      }),
    ),
  );
